import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/message.png'
import _imports_1 from '@/assets/images/close-message.png'


_pushScopeId("data-v-753d7bc0")
const _hoisted_1 = { class: "guiji-layout" }
const _hoisted_2 = {
  key: 0,
  class: "broadcast-tip"
}
const _hoisted_3 = { class: "marquee-container" }
const _hoisted_4 = { class: "scroll-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1)
const _hoisted_6 = { class: "message-text" }
const _hoisted_7 = { class: "right-conent" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = {
  key: 0,
  class: "service-area"
}
const _hoisted_10 = { class: "title" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "icon-avatar" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "button icon-kefu" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CertificationBar = _resolveComponent("CertificationBar")!
  const _component_LeftNav = _resolveComponent("LeftNav")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CertificationBar),
    (_ctx.systemMessage.announcement?.type == 2 && _ctx.systemMessage.announcement?.content)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "marquee-content",
              style: _normalizeStyle({ animationDuration: _ctx.marqueeSpeed })
            }, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.systemMessage.announcement?.content), 1)
              ])
            ], 4)
          ]),
          _createElementVNode("img", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCloseBroadCastMessage && _ctx.handleCloseBroadCastMessage(...args))),
            class: "img close",
            src: _imports_1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_LeftNav, {
        class: _normalizeClass(_ctx.isCollapse ? 'left-nav' : 'hasBgImg left-nav')
      }, null, 8, ["class"]),
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        (!_ctx.isEditorPage && !_ctx.is3Part && !_ctx.isBatchVideo && !_ctx.isPictureSpeaker && !_ctx.isAiKnowledge)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_el_popover, {
                "popper-class": "service-popover",
                placement: "left-end",
                width: 168,
                trigger: "click"
              }, {
                reference: _withCtx(() => [
                  _hoisted_13
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createTextVNode(_toDisplayString(_ctx.lang('common.text.wechat')), 1)
                    ]),
                    _hoisted_12
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}